<template>
      <div class="modal-card">

                    <b-loading :is-full-page=true v-model="isLoadingFullPage" ></b-loading>
                  
                    <header class="modal-card-head "  > <!-- icon-left="arrow-left-bold-circle"  -->
                                <b-button type="is-text" 
                                    size="is-large"
                                    icon-left="arrow-left-bold-circle"
                                    style="margin-top:25px;"
                                    @click="close">Back</b-button> 


                                    <b-field grouped>
                                        <b-field label="Find in">
                                               <b-dropdown
                                                        v-model="selectedOptions"
                                                        multiple
                                                        aria-role="list">
                                                        <template #trigger>
                                                            <b-button
                                                                type="is-primary"
                                                                icon-right="menu-down">
                                                                Find in ({{ selectedOptions.length }})
                                                            </b-button>
                                                        </template>


                                                        <b-dropdown-item value="CYTO_PREPARE" aria-role="listitem">
                                                            <span>Cyto Sample Information</span>
                                                        </b-dropdown-item>

                                                        <b-dropdown-item value="CYTO_CT" aria-role="listitem">
                                                            <span>Cyto Findings And Comments</span>
                                                        </b-dropdown-item>

                                                        <b-dropdown-item value="BIOPSY_PREPARE" aria-role="listitem">
                                                            <span>Biopsy Sample Information</span>
                                                        </b-dropdown-item>


                                                        <b-dropdown-item value="BIOPSY_CT" aria-role="listitem">
                                                            <span>Biopsy Findings And Comments</span>
                                                        </b-dropdown-item>


                                                    </b-dropdown>
                                        </b-field>
                                        <b-field label="Search" expanded>
                                            <b-input v-model="searchTxt"></b-input>
                                        </b-field>
                                        <b-field label="#" expanded>

                                                    <template #label>
                                                      <span class="has-text-white-ter">#</span> 
                                                    </template>


                                                        <b-button 
                                                            icon-left="file-search-outline"
                                                            @click="searchFindDataResult"
                                                            >
                                                            Search
                                                        </b-button>
                                        </b-field>
                                    </b-field>

                    </header>



                    <section class="modal-card-body">
 
            <b-table
                            :data="isEmpty ? [] : dataResultSearch  "
                            bordered
                            striped
                            narrowed
                            hoverable
                            focusable
                            mobile-cards
                                >

                            <b-table-column  label="Lab No."  v-slot="props">
                                {{ props.row.idlab }}
                            </b-table-column>

                            <b-table-column  label="OPD No."  v-slot="props">
                                {{ props.row.idopd }}
                            </b-table-column>


                            <b-table-column  label="OPD Name"  v-slot="props">
                                {{ props.row.opd_name }}
                            </b-table-column>


                            <b-table-column  label="Owner"  v-slot="props">
                                {{ props.row.owner_name }}  {{ props.row.owner_surname }}
                            </b-table-column>



                            <b-table-column  label="Content"  width="60%" v-slot="props">
                              <div v-html="decodeDataWithMarkElement(  props.row.data_txt  )"></div>
                            </b-table-column>



                            <b-table-column  label="Found in"  width="12%" v-slot="props">
                              {{ decodeTypeOfCt(props.row.type_of_ct) }}
                            </b-table-column>


                             <b-table-column  label="View document" >
                                  <b-button type="is-primary" outlined 
                                  icon-left="file-document-outline"
                                   ></b-button>
                            </b-table-column>

                            

                            


                        

                            <template slot="empty">
                                <section class="section">
                                    <div class="content has-text-grey has-text-centered">
                                        <p>
                                            <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Nothing.</p>
                                    </div>
                                </section>
                            </template>


                      
            
            
            </b-table>

            



                    </section>
      </div>
</template>      


<script>
import { mapState } from "vuex";
import axios from "axios";
 import { getBaseURLforBackEnd  ,    getConfigAxios ,  }  from '@/utils.js'

export default {
    
    name :  "SearchSomeTextInLab",
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()
                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },
    computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            }),
    },        
    methods:{
        decodeTypeOfCt(dat){
        //    CYTO_PREPARE, CYTO_CT, BIOPSY_PREPARE, BIOPSY_CT
        if (dat == 'CYTO_PREPARE' ){
             return 'Cyto Sample Information'
        }
        if (dat == 'CYTO_CT' ){
             return 'Cyto Findings And Comments'
        }
        if (dat == 'BIOPSY_PREPARE' ){
             return 'Biopsy Sample Information' 
        }
        if (dat == 'BIOPSY_CT' ){
              return 'Biopsy Findings And Comments' 
        }

        return ''
        },
        decodeDataWithMarkElement(dat){
                const txt =  dat ? Buffer.from( dat , 'base64').toString('utf-8') : ''
          



                
               const markedTxt = txt.replace(new RegExp(this.searchArr.join('|'), 'gi'), match => `<mark>${match}</mark>`);




                return markedTxt  
        },
        close(){
            this.$emit('close')
        },
        searchFindDataResult(){
                this.isLoadingFullPage = true 
                this.searchArr = [this.searchTxt]

                this.selectedOptions[0]
                const searchin = [ this.selectedOptions.indexOf('CYTO_PREPARE')>-1 ,
                                   this.selectedOptions.indexOf('CYTO_CT')>-1 ,
                                   this.selectedOptions.indexOf('BIOPSY_PREPARE')>-1 ,
                                   this.selectedOptions.indexOf('BIOPSY_CT')>-1 
                                   ]
                const datTo =  {
                                "keyword" : this.searchArr, 
                                "searchin" : searchin,
                                "date_start" :  "2021-01-01T00:00:00.000Z",
                                "date_stop" :   "2021-12-31T00:00:00.000Z",
                                "first" : 50,
                                "skip" :  0
                                }



                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/searchtxt_in_patholabrecord`, datTo, getConfigAxios())
                    .then((res)=>{
                         this.dataResultSearch = res.data
                         this.isLoadingFullPage = false
                    })
                    .catch(()=>{
                         this.isLoadingFullPage = false
                    })
        }
    },
    data(){
        return {
            isLoadingFullPage : false,
            selectedOptions : ['CYTO_PREPARE','CYTO_CT','BIOPSY_PREPARE','BIOPSY_CT'],
            searchTxt : "",
            searchArr : [],

            dataResultSearch : [],

            isEmpty : false,

        }
    }
}
</script>

